export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 4c1.917 0 3.6.983 4.583 2.467A6.5 6.5 0 1117.5 19H5A5 5 0 015 9h.023A5.5 5.5 0 0110.5 4zm0 2a3.5 3.5 0 00-3.464 3.998 1 1 0 01-1.25 1.107A3 3 0 105 17h12.499a4.5 4.5 0 10-2.322-8.357 1.001 1.001 0 01-1.442-.476A3.5 3.5 0 0010.5 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};